import React from "react";

export function SiteFooter({ usesSponsorBlock = false }) {
  return (
    <footer className="site-footer section-wrap">
      {usesSponsorBlock && <div className="site-footer__sponsor">Uses SponsorBlock community data.</div>}
      <div className="site-footer__main">
        <span>Independent project. Not affiliated with or endorsed by Theo or YouTube.</span>
        <span>Long videos. Smarter playback.</span>
      </div>
      <div className="site-footer__meta">
        <a href="https://x.com/bayramgnb" target="_blank" rel="noreferrer">Made by @bayramgnb</a>
      </div>
    </footer>
  );
}
